const buttonSizes = (css, theme, styleUtils) => ({
  micro: css`
    ${styleUtils.base.square({
    size: '16px'
  })};
  `,
  xSmall: css`
    ${styleUtils.base.square({
    size: '20px'
  })};
  `,
  small: css`
    ${styleUtils.base.square({
    size: '24px'
  })};
  `,
  medium: css`
    ${styleUtils.base.square({
    size: '32px'
  })};
  `,
  large: css`
    ${styleUtils.base.square({
    size: '40px'
  })};
  `,
  xLarge: css`
    ${styleUtils.base.square({
    size: '48px'
  })};
  `
});

const iconSizes = css => ({
  micro: css`
    font-size: 12px;
  `,
  xSmall: css`
    font-size: 16px;
  `,
  small: css`
    font-size: 20px;
  `,
  medium: css`
    font-size: 20px;
  `,
  large: css`
    font-size: 24px;
  `,
  xLarge: css`
    font-size: 24px;
  `
});

const loaderSizes = {
  micro: 12,
  xSmall: 16,
  small: 20,
  medium: 20,
  large: 24,
  xLarge: 24
};
export default ((css, theme, styleUtils) => ({
  buttonSizes: buttonSizes(css, theme, styleUtils),
  iconSizes: iconSizes(css),
  loaderSizes
}));